import { render, staticRenderFns } from "./BaseLocal.vue?vue&type=template&id=79abc02f&"
import script from "./BaseLocal.vue?vue&type=script&lang=js&"
export * from "./BaseLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports